/* ============
 * SMS Two Factor Authentication
 * ============
 *
 * This is the page for two factor auth.
 */
import { mapGetters, mapMutations } from 'vuex';
import googleTwoFactorAuthService from '../../services/googleTwoFactorAuthSetup';
import modulesService from './../../services/modules';

export default {
  data() {
    return {
      google2faEnabled: false,
      verificationSent: false,
      twoFactorAuthToken: null,
      verified: false,
      qrCodeImage: null,
      secretKey: null,
      loading: false,
      verifyLoading: false,
    };
  },

  props: {
    module: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      account: 'account',
      modules: 'allModules',
    }),
    isSms2faEnabled() {
      return this.modules.find(module => (module.name === 'Sms Two-Factor Authentication' && module.subscribe));
    },
  },

  created() {
    if (!this.isSms2faEnabled) {
      this.twoFactorAuthToken = null;
      this.enable2FA();
    }
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),
    enable2FA() {
      this.loading = true;
      const data = {
        user_id: this.account.userId,
        module_id: this.module.id,
      };
      Promise.resolve(googleTwoFactorAuthService.enabledGoogleTwoFactor(data))
        .then((response) => {
          this.qrCodeImage = response.data.image;
          this.loading = false;
        })
        .catch(() => {
          this.google2faEnabled = true;
          this.loading = false;
        });
    },
    /**
     * This method will be called when saving the form.
     */
    verifyToken() {
      if (!this.twoFactorAuthToken) {
        this.$message({
          message: this.$t('static.googleTwoFactorVerification.verificationCodeIncorrect'),
          type: 'error',
        });
        return;
      }

      this.verifyLoading = true;
      const data = {
        code: this.twoFactorAuthToken,
        user_id: this.account.userId,
        module_id: this.module.id,
      };
      Promise.resolve(googleTwoFactorAuthService.verifyToken(data))
        .then(() => {
          modulesService.items().then(() => {
            this.verifyLoading = false;
            this.$message({
              message: this.$t('static.googleTwoFactorVerification.smsTwoFactorAuthEnabled'),
              type: 'success',
            });
            this.closeModal();
          });
        })
        .catch(() => {
          this.verifyLoading = false;
          this.$message({
            message: this.$t('static.googleTwoFactorVerification.verificationCodeIncorrect'),
            type: 'error',
          });
        });
    },
    /*
      * Closes the modal
      */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/googleTwoFactorAuthSetup/googleTwoFactorAuthSetup.js